import type { EntityConfig } from '../types'

export const clearingBatchEntity: EntityConfig = {
  name: 'clearing-batch',
  displayName: 'Clearing Batch',
  pluralName: 'Clearing Batches',
  status: {
    field: 'status',
    options: [
      { value: 'pending', label: 'Pending', color: 'warning' },
      { value: 'processing', label: 'Processing', color: 'info' },
      { value: 'cleared', label: 'Cleared', color: 'success' },
      { value: 'failed', label: 'Failed', color: 'error' },
      { value: 'partial', label: 'Partial', color: 'warning' },
    ],
    filters: [
      { label: 'All', value: 'all' },
      { label: 'Pending', value: 'pending' },
      { label: 'Processing', value: 'processing' },
      { label: 'Cleared', value: 'cleared' },
      { label: 'Failed', value: 'failed' },
      { label: 'Partial', value: 'partial' },
    ],
    mappings: {
      all: ['pending', 'processing', 'cleared', 'failed', 'partial'],
      pending: ['pending'],
      processing: ['processing'],
      cleared: ['cleared'],
      failed: ['failed'],
      partial: ['partial'],
    },
  },
  queryFields: {
    status: { field: 'status', type: 'select', label: 'Status' },
    clearingHouse: { field: 'clearingHouse', type: 'select', label: 'Clearing House' },
  },
  uiFilterFields: ['status', 'clearingHouse'],
}
